import { render, staticRenderFns } from "./ReassignModal.vue?vue&type=template&id=4f51a119&scoped=true&"
import script from "./ReassignModal.vue?vue&type=script&lang=js&"
export * from "./ReassignModal.vue?vue&type=script&lang=js&"
import style0 from "./ReassignModal.vue?vue&type=style&index=0&id=4f51a119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51a119",
  null
  
)

export default component.exports